<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" dark v-bind="attrs" v-on="on">
        <v-icon left dense>mdi-plus</v-icon>
        Submit job opening
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dark color="primary" dense>
        <v-toolbar-title>Submit job opening</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn text color="white" :disabled="!termsAccepted" @click="save()"
            >Submit</v-btn
          >

          <v-btn text color="white" @click="clearAndClose()"
            >Discard</v-btn
          ></v-toolbar-items
        >
      </v-toolbar>
      <v-card-text>
        <v-row style="display: flex">
          <v-col style="flex: 2; overflow-y: scroll" class="dialogcol pt-8">
            <v-form ref="newJobForm" lazy-validation>
              <v-alert
                dismissible
                color="red"
                text
                :value="message.length > 0"
                >{{ message }}</v-alert
              >
              <h2>Job details</h2>
              <p>
                Please note that both company and open vacancy listings require
                processing and approval of your local Talent Hub. After
                approval, listings will be published on the Jobs in Finland
                website.
              </p>
              <v-text-field
                required
                :rules="rules.urlRules"
                v-model="url"
                label="Link to job opening *"
                placeholder="https://"
                outlined
              ></v-text-field>
              <v-text-field
                required
                :rules="rules.notEmptyRules"
                v-model="title"
                label="Job title *"
                placeholder="Enter job title"
                outlined
              ></v-text-field>

              <h3>Employer details</h3>
              <v-combobox
                required
                :rules="rules.notEmptyRules"
                v-model="selectedEmployer"
                :items="getEmployers"
                label="Employer name *"
                placeholder="Select existing or create a new organisation"
                outlined
                item-text="name"
                @change="employerSelected()"
              ></v-combobox>
              <v-text-field
                required
                :rules="rules.notEmptyRules"
                label="Link to website *"
                outlined
                v-model="employer.externalUrl"
              >
              </v-text-field>
              <v-text-field
                label="Link to careers page"
                outlined
                v-model="employer.careersUrl"
              ></v-text-field>
              <v-text-field
                v-model="employer.imageUrl"
                label="Logo URL"
                placeholder="Enter URL of employer logo"
                outlined
              ></v-text-field>
              <h3>Job details</h3>
              <v-text-field
                required
                :rules="rules.emailRules"
                v-model="contactPerson.email"
                label="Job opening contact email *"
                outlined
                placeholder="hr@company.fi"
              >
              </v-text-field>
              <v-text-field
                required
                :rules="rules.notEmptyRules"
                v-model="city"
                label="City *"
                placeholder="Enter city or cities"
                outlined
              ></v-text-field>
              <v-select
                required
                :rules="rules.notEmptyRules"
                v-model="area"
                :items="areaItems"
                label="Region *"
                outlined
              ></v-select>
              <v-text-field
                required
                :rules="rules.notEmptyRules"
                v-model="country"
                label="Country *"
                placeholder="Enter country"
                outlined
                readonly
              ></v-text-field>

              <v-menu
                v-model="publishMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="publish"
                    :rules="rules.notEmptyRules"
                    label="Job posting should be published on *"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  required
                  v-model="publish"
                  @input="publishMenu = false"
                ></v-date-picker>
              </v-menu>

              <v-menu
                v-model="expiresMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="expires"
                    :rules="rules.notEmptyRules"
                    label="Job posting expires on *"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  required
                  v-model="expires"
                  @input="expiresMenu = false"
                ></v-date-picker>
              </v-menu>
              <v-row class="align-center flex-nowrap" dense>
                <v-checkbox v-model="termsAccepted" dense></v-checkbox>
                <label class="mb-2"
                  >I have read and accept the
                  <a @click="termsDialog = true">{{ terms.title }}</a
                  >. *</label
                >
              </v-row>
              <TermsModal :show.sync="termsDialog" :terms="terms"></TermsModal>
              <p><small>* Required field</small></p>
            </v-form>
          </v-col>
          <v-col style="flex: 3; position: relative">
            <iframe
              :src="url"
              style="
                width: 100%;
                height: 80vh;
                border: 4px solid rgba(0, 0, 0, 0.2);
                box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.2);
                border-radius: 10px;
              "
            >
            </iframe>
            <div
              style="
                box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
                font-size: 0.8rem;
                position: absolute;
                top: -6px;
                left: -6px;
                display: block;
                padding: 0.5rem 1rem;
                background: white;
                border-radius: 6px;
              "
            >
              URL PREVIEW
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import TermsModal from "@/components/TermsModal.vue";
import { cityToLocation } from "../utils";

export default {
  components: {
    TermsModal,
  },
  props: {
    dialog: Boolean
  },
  data() {
    return {
      message: "",
      publishMenu: false,
      expiresMenu: false,
      url: "",
      categories: "",
      tags: "",
      area: "",
      city: "",
      description: "",
      title: "",
      employer: {
        name: "",
        imageUrl: "",
        externalUrl: "",
        careersUrl: "",
      },
      selectedEmployer: null,
      imageURL: "",
      country: "Finland",
      publish: "",
      expires: "",
      defaultContactEmail: "",
      contactEmail: "",
      termsAccepted: false,
      termsDialog: false,
      terms: {},
      rules: {
        notEmptyRules: [(v) => !!v || "Please fill out this field"],
        emailRules: [
          (v) => !!v || "Please fill out this field",
          (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        ],
        urlRules: [
          (v) => !!v || "Please fill out this field",
          (v) =>
            /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(
              v
            ) || "Url must be valid and start with http(s)://",
        ],
      },
    };
  },
  mounted() {
    this.$store.dispatch("dispatchGetEmployers");

    this.$store.dispatch("dispatchGetPages").then((pages) => {
      this.terms = pages.find(
        (page) => page.id == "terms-of-use-for-job-poster"
      );
    });
  },
  watch: {
    city: function () {
      const location = cityToLocation(this.city);
      this.area = location.area;
      this.country = location.country ? location.country : "Finland";
    },
  },
  computed: {
    tagItems() {
      return this.$store.state.tags;
    },
    areaItems() {
      const areas = this.$store.state.mapData.map((area) => area.name);
      return areas;
    },
    newEmployer() {
      return (
        typeof this.selectedEmployer !== "object" &&
        this.selectedEmployer !== null
      );
    },
    contactPerson() {
      if (
        typeof this.selectedEmployer == "object" &&
        this.selectedEmployer !== null &&
        this.selectedEmployer.contact !== undefined
      ) {
        return this.selectedEmployer.contact;
      } else {
        return { email: this.defaultContactEmail };
      }
    },
    getEmployers() {
      return this.$store.state.employers.employers;
    },
  },
  methods: {
    employerSelected() {
      console.log(this.selectedEmployer);
      if (!this.newEmployer) {
        this.employer = this.selectedEmployer;
      } else {
        this.employer = {
          name: this.selectedEmployer,
          imageUrl: "",
          externalUrl: "",
          careersUrl: "",
        };
      }
    },
    jobData() {
      let data = {
        title: this.title,
        description: this.description,
        imageUrl: this.employer.imageUrl,
        externalUrl: this.url,

        employer: {
          id: this.newEmployer ? null : this.selectedEmployer.id,
          name: this.newEmployer
            ? this.selectedEmployer
            : this.selectedEmployer.name,
          imageUrl: this.employer.imageUrl,
          externalUrl: this.employer.externalUrl,
          careersUrl: this.employer.careersUrl,
          location: {
            city: this.city,
            area: this.area,
            country: this.country,
          },
          source: "jobsinfinland.fi-v1.0",
        },

        location: {
          area: this.area,
          city: this.city,
          country: this.country,
        },

        source: {
          apiId: "",
          documentId: "",
          firstSeen: "",
          lastSeen: "",
          contactEmail: this.contactPerson.email,
        },

        schedule: {
          publish: this.publish ? this.publish + "T23:59:59.000Z" : "",
          expire: this.expires ? this.expires + "T23:59:59.000Z" : "",
        },

        clustering: {
          categories: this.categories
            ? this.categories.map((category) => {
                return { label: category };
              })
            : [],
          tags: this.tags
            ? this.topics.map((tag) => {
                return { label: tag.id };
              })
            : [],
          position: {
            x: 0,
            y: 0,
          },
        },
      };

      delete data.employer.id;

      return data;
    },
    save() {
      let data = this.jobData();
      console.log(data);

      // Validate form
      let valid = this.$refs.newJobForm.validate();

      if (valid) {
        this.message = "";
        // Send form
        this.$store
          .dispatch("dispatchPostJob", { jobData: data })
          .then(() => {
            this.$emit("jobCreated");
            this.clearAndClose();
            this.$store.dispatch("commitSnackbar", {
              show: true,
              message: "Job opening sent succesfully.",
              timeout: 4000,
              color: "primary",
            });
          })
          .catch((error) => {
            console.log(error);
            this.$store.dispatch("commitSnackbar", {
              show: true,
              message: "There was an error when submitting the form.",
              timeout: 6000,
              color: "error",
            });
          });
      } else {
        this.message = "Please fill the required fields in a valid format.";
      }
    },
    clearAndClose() {
      this.$refs.newJobForm.reset();
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
.dialogcol {
  height: calc(100vh - 64px);
}
</style>
